import { Link } from 'react-router-dom';
import { MapPin, HandHeart } from '@phosphor-icons/react';

export const ArtisanCard = ({ artisan }) => {
  return (
    <Link to={`/artisans/${artisan.id}`} data-testid={`artisan-card-${artisan.id}`}>
      <div className="artisan-card relative overflow-hidden aspect-[4/5] group cursor-pointer rounded-xl">
        {/* Background Image */}
        <img
          src={artisan.image_url || 'https://images.pexels.com/photos/32160894/pexels-photo-32160894.jpeg'}
          alt={artisan.name}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />

        {/* Gradient Overlay */}
        <div className="artisan-overlay absolute inset-0 bg-gradient-to-t from-[#2C3E2D]/95 via-[#2C3E2D]/30 to-transparent" />

        {/* Content */}
        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
          <div className="flex items-center gap-2 mb-2 text-white/70 text-sm">
            <MapPin weight="duotone" className="w-4 h-4" />
            <span>{artisan.location}</span>
          </div>
          <h3 className="text-xl font-semibold mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>
            {artisan.name}
          </h3>
          <p className="text-white/80 text-sm mb-3">{artisan.craft_specialty}</p>
          
          <div className="flex items-center gap-4 text-sm">
            <div className="flex items-center gap-1.5">
              <HandHeart weight="duotone" className="w-4 h-4" />
              <span>{artisan.years_experience} years</span>
            </div>
            <div className="text-white/70">
              {artisan.products_created} products
            </div>
          </div>
        </div>

        {/* Hover Effect */}
        <div className="absolute inset-0 border-2 border-transparent group-hover:border-white/30 rounded-xl transition-colors duration-300" />
      </div>
    </Link>
  );
};

export default ArtisanCard;
